import React, { useState } from 'react'
import './index.css'
import { ContractStage } from '../../types'

type Props = {
    tab: string
    tabs: string[]
    onTabChange: (newTab: string) => void
    theme: string
}

const ContractTab: React.FC<Props> = ({ tab, tabs, onTabChange, theme }) => {
    return (
        <div className="flex flex-row ">
            <div className="w-5"></div>
            {tabs.map((item, index) => {
                return (
                    <div
                        key={index}
                        className={`cursor-pointer ${
                            tab == item
                                ? 'w-60 h-7 content-center rounded-t-[10px] text-center text-sm text-[#181818] bg-[#f0f3f5] dark:bg-[#181818] dark:text-[#FFFFFF]'
                                : 'w-60 h-7 content-center rounded-t-[10px] text-center text-xs hover:text-sm text-[#6A6A6A] dark:text-[#8A8A8A] hover:text-[#181818] hover:bg-[#f0f3f5] dark:hover:bg-[#181818] dark:hover:text-[#FFFFFF]'
                        }`}
                        onClick={() => {
                            onTabChange(item)
                        }}
                    >
                        <div className="flex flex-row w-full h-full items-center justify-center gap-2">
                            {item}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default ContractTab
